import { Link, useLocation } from 'react-router-dom';
import NavBar from 'components/NavBar';
import Icon from 'components/Icon';
import useMetadadosPagina from 'hooks/useMetadadosPagina';
import { descreverErro } from 'services/erros';
import { CodigoDoErro } from 'components/MensagemErro';

/**
 * Rota curinga (path="*" em src/App.jsx). Até existir, uma URL desconhecida casava com nenhum
 * <Route> e o <Routes> não renderizava nada: a NavBar não aparecia (quem a monta é cada página),
 * o rodapé aparecia, e entre os dois ficava um vazio sem explicação nenhuma.
 *
 * Na web isso já era ruim; em app nativo é uma armadilha — não há barra de endereço para corrigir
 * a URL nem botão de voltar do navegador, então a única saída de uma rota inválida é a que esta
 * tela oferecer. Daí a NavBar aqui e os dois caminhos explícitos abaixo.
 *
 * O caminho tentado aparece em tela porque a causa mais comum é link antigo ou digitação: ver
 * qual endereço falhou é o que permite ao usuário perceber o erro (e ao suporte reproduzi-lo).
 */
export default function NaoEncontrada() {
    // noindex: o nginx devolve o index.html com status 200 para qualquer caminho (fallback do SPA),
    // então sem isto uma URL inexistente seria indexada como página válida — o "soft 404".
    useMetadadosPagina({ titulo: 'Página não encontrada | Nova Faxina', indexar: false });

    const { pathname } = useLocation();

    return (
        <div className="page-shell min-h-screen">
            <NavBar />

            <div className="flex items-start justify-center px-4 pb-12 pt-24 sm:pt-32">
                <div className="card-page w-full max-w-lg text-center">
                    <div className="icone-circulo mx-auto h-20 w-20">
                        <Icon name="search" className="h-9 w-9" />
                    </div>

                    <h1 className="t-pagina mt-6">Página não encontrada</h1>

                    <p className="mt-3 text-base text-muted">
                        O endereço que você tentou abrir não existe ou foi movido.
                    </p>

                    <p className="mt-4 break-all rounded-lg bg-subtle px-4 py-2 font-mono text-xs text-muted">
                        {pathname}
                    </p>
                    <CodigoDoErro descricao={descreverErro('GER-101')} className="mt-2 justify-center" />

                    <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:justify-center">
                        <Link to="/" className="btn-primary justify-center">
                            Ir para a página inicial
                        </Link>
                        <Link to="/ajuda" className="btn-secondary justify-center">
                            Central de ajuda
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
